import './styles/libs.scss';
import './styles/main.scss';

import $ from 'jquery';
import 'jquery-validation';
import 'jquery-validation-unobtrusive';

$(function () {
    const viewNames = [...new Set(
        $('[data-views]')
            .map((_, el) => $(el).data('views')?.split(','))
            .get()
            .flat()
            .filter(Boolean)
    )];

    viewNames.forEach(async viewName => {
        try {
            if (viewName === 'login') { await import(/* webpackChunkName: "login" */ './js/views/login.js'); }
            if (viewName === 'otp-selection') { await import(/* webpackChunkName: "otp-selection" */ './js/views/otp-selection.js'); }
            if (viewName === 'otp-verify') { await import(/* webpackChunkName: "otp-verify" */ './js/views/otp-verify.js'); }
            if (viewName === 'password-reset') { await import(/* webpackChunkName: "password-reset" */ './js/views/password-reset.js'); }
            if (viewName === 'forgotten-password') { await import(/* webpackChunkName: "forgotten-password" */ './js/views/forgotten-password.js'); }
        } catch (error) {
            console.error(`Failed to load Js for ${viewName}:`, error);
        }
    })
});